/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibraryopenoriginal3Inputs */

const en_medialibraryopenoriginal3 = /** @type {(inputs: Medialibraryopenoriginal3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open in new tab`)
};

const de_medialibraryopenoriginal3 = /** @type {(inputs: Medialibraryopenoriginal3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In neuem Fenster öffnen`)
};

/**
* | output |
* | --- |
* | "Open in new tab" |
*
* @param {Medialibraryopenoriginal3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibraryopenoriginal3 = /** @type {((inputs?: Medialibraryopenoriginal3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibraryopenoriginal3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibraryopenoriginal3(inputs)
	return de_medialibraryopenoriginal3(inputs)
});
export { medialibraryopenoriginal3 as "mediaLibraryOpenOriginal" }